import React, { Component } from "react";
import Throbber from "../../components/Throbber";
import CustomersList from "./CustomersList";
import Jumbotron from "../../components/Jumbotron";
import Alert from "../../components/Alert";
import AlignCenter from "../../components/AlignCenter";
import PageLayout from "../../components/PageLayout";
import NavBar from "../../NavBar/NavBar";

import { connect } from "react-redux";
import {
  getCustomersPending,
  getCustomersList,
} from "../../../redux/modules/customers/reducer";
import { pushRoute } from "../../../redux/modules/route/actions";
import { ROUTE_SITES, generate } from "../../../redux/modules/route/routes";

import { CustomersState } from "../../../redux/modules/customers/reducer";
import { UserState } from "../../../redux/modules/user/reducer";
import { userOpensCustomersListPage } from "./scenarios";
import { AppDispatch } from "../../../store";
import { GlobalState } from "../../../redux/modules/rootReducer";

type CustomersListPageProps = {
  dispatch: AppDispatch;
  customersState: CustomersState;
  userState: UserState;
};
type CustomersListPageState = {
  isLoading: boolean;
  errorMessage: string | null;
};
class CustomersListPage extends Component<
  CustomersListPageProps,
  CustomersListPageState
> {
  state = {
    isLoading: true,
    errorMessage: null,
  };

  async componentDidMount() {
    try {
      await this.props.dispatch(userOpensCustomersListPage());
      this.setState({
        isLoading: false,
        errorMessage: null,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        errorMessage: error.message,
      });
    }
  }

  render() {
    return (
      <PageLayout
        navBar={<NavBar />}
        header={this.renderHeader()}
        content={this.renderContent()}
      />
    );
  }

  renderHeader() {
    const { customersState } = this.props;
    const customersPending = getCustomersPending(customersState);
    const customersList = getCustomersList(customersState);

    if (customersPending) {
      return (
        <Jumbotron imageUrl={"backoffice-logo.svg"} header={`Backoffice`} />
      );
    }

    return (
      <Jumbotron
        imageUrl={"backoffice-logo.svg"}
        header={`Backoffice`}
        subheader={`${customersList.length} customers`}
      />
    );
  }

  renderContent() {
    const { isLoading, errorMessage } = this.state;
    const { customersState, dispatch } = this.props;

    if (isLoading) {
      return (
        <AlignCenter>
          <Throbber />
        </AlignCenter>
      );
    }

    if (errorMessage) {
      return <Alert>{errorMessage}</Alert>;
    }

    const customersList = getCustomersList(customersState);

    return (
      <CustomersList
        customers={customersList}
        onCustomerClick={customerId => {
          dispatch(pushRoute(generate(ROUTE_SITES, { customerId })));
        }}
      />
    );
  }
}

export default connect((state: GlobalState) => {
  return {
    userState: state.user,
    customersState: state.customers,
  };
})(CustomersListPage);
